import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/about-us/page.tsx");
